// extracted by mini-css-extract-plugin
export var root = "Tags-module--root--lAAwZ";
export var showButton = "Tags-module--showButton--m229a";
export var singleLine = "Tags-module--singleLine--hqrPp";
export var tag = "Tags-module--tag--FlxNG";
export var tagHeading = "Tags-module--tagHeading--ihsot";
export var tags = "Tags-module--tags--aetpP";